<template lang="html">
  <div v-if="account" class="row">
    <div class="col-12">
      <article class="fc-m-container">
        <h2>Join a public league</h2>
        <p>
          Public leagues are administered by Fantasy Congress and run for 8
          weeks. We'll randomly place you and a minimum of four other players in
          a league. Drafts take place via auto-draft. You'll receive a
          notification via email once you are placed in a league.
        </p>
        <div class="row p-0">
          <div class="col-12 col-md-8 col-lg-6">
            <form v-if="!waitlisted" @submit="joinPublicLeague" class="pb-4">
              <div class="form-group">
                <label for="name">Enter your team name:</label>
                <input
                  required
                  class="form-control"
                  type="text"
                  name="teamName"
                  v-model="teamName"
                  value=""
                />
              </div>
              <button type="submit" class="btn btn-primary">Sign up</button>
            </form>
            <div v-else>
              <div class="alert alert-warning">
                <p>You are on the waitlist to join a public league.</p>
                Your team name is: <strong>{{ account.misc.team_name }}</strong>
              </div>
              <div class="">
                <button @click="cancelPublicLeague" class="btn btn-secondary">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
  <loader v-else v-bind:embeded="false"></loader>
</template>

<script>
import { getCookie } from "@/utils/cookies.js";
import Loader from "@/views/components/Loader";

export default {
  name: "PublicLeagues",
  components: {
    loader: Loader
  },
  data: function() {
    return {
      teamName: "",
      account: null,
      waitlisted: false
    };
  },
  created: function() {
    if (this.$store.state.auth.is_customer == false) {
      this.$router.push("/account");
      this.$store.commit("alert/addMessage", {
        message: `Upgrade your account in order to join public leagues!`,
        class: "warning",
        persist: false
      });
    } else if (this.$store.state.auth.account_type != "individual") {
      this.$router.push("/leagues");
      this.$store.commit("alert/addMessage", {
        message: `You do not have access to view that page.`,
        class: "warning",
        persist: false
      });
    } else {
      let app = this;
      fetch(
        process.env.VUE_APP_PLATFORM +
          "/accounts/" +
          this.$store.state.auth.user_id +
          "/",
        {
          credentials: "include",
          mode: "cors"
        }
      )
        .then(function(response) {
          return response.json();
        })
        .then(function(response) {
          let miscKeys = Object.keys(response.misc);
          let hasData = miscKeys.filter(key => key == "public_league");
          if (hasData.length > 0) {
            app.waitlisted = response.misc.public_league;
          }
          app.account = response;
        });
    }
  },
  methods: {
    getUser: function() {},
    joinPublicLeague: function(e) {
      e.preventDefault();

      let app = this;
      const csrftoken = getCookie("csrftoken");

      let form = {
        misc: {
          team_name: app.teamName,
          public_league: true
        }
      };

      let status = 0;
      fetch(
        `${process.env.VUE_APP_PLATFORM}/accounts/${
          app.$store.state.auth.user_id
        }/`,
        {
          credentials: "include",
          method: "PATCH",
          mode: "cors",
          body: JSON.stringify(form),
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrftoken
          }
        }
      )
        .then(function(response) {
          status = response.status;
          return response.json();
        })
        .then(function(response) {
          if (status == 200) {
            app.$router.push("/leagues/");
            app.$store.commit("alert/addMessage", {
              message: `You are on the waitlist to join a public league!`,
              class: "success",
              persist: false
            });
          } else {
            app.$store.commit("alert/addMessage", {
              message: `Unable to join waitlist at this time.`,
              class: "danger",
              persist: false
            });
          }
        });
    },
    cancelPublicLeague: function() {
      let app = this;
      const csrftoken = getCookie("csrftoken");

      let form = {
        misc: {
          team_name: "",
          public_league: false
        }
      };

      let status = 0;

      fetch(
        `${process.env.VUE_APP_PLATFORM}/accounts/${
          app.$store.state.auth.user_id
        }/`,
        {
          credentials: "include",
          method: "PATCH",
          mode: "cors",
          body: JSON.stringify(form),
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrftoken
          }
        }
      )
        .then(function(response) {
          status = response.status;
          return response.json();
        })
        .then(function(response) {
          if (status == 200) {
            app.$router.push("/leagues/");
            app.$store.commit("alert/addMessage", {
              message: `You have been removed from the waitlist.`,
              class: "success",
              persist: false
            });
          }
        });
    }
  }
};
</script>

<style lang="css" scoped></style>
